import React, { useEffect, useState } from "react";

import List from "./List";
import styles from "../NotesPage.module.scss";

const Body = ({ notesAll, notesArchive, setNotes }) => (
  
  <div className={styles["note-app__body"]}>
  

    <List label="Ваши заметки" setNotes={setNotes} notes={notesAll} />
  
    <List label="Архив" setNotes={setNotes} notes={notesArchive} />
  </div>
);

export default Body;
